<template>
  <div id="content-wrap">
    <input v-if="0>1" type="button" value="testFunction" @click="testFunction()" />
    <div class="box box-widget widget-user-2">
      <div @click="goHome()" class="widget-user-header" style="background-color: #367fa9; cursor: pointer;">
        <img src="../../static/img/logo-small.png" style="height: 80px; cursor: pointer; padding-left: 1%;" alt="Printer Counters" />
        <h4 class="widget-user-desc" style="margin-left: 5%; cursor: pointer;">Printer Counters Monitoring</h4>
        <h5 class="widget-user-desc" style="margin-left: 5%; cursor: pointer;">Ver. {{$root.version}}</h5>
      </div>
      <!--<div class="widget-user-header" style="background-color: #367fa9; color: #fff; cursor: pointer; padding: 5px 20px;">
        <a id="btnDownloadGuide" style="color: #fff;" target="_blank" href="https://firebasestorage.googleapis.com/v0/b/b-info.appspot.com/o/Documentation%2FPrinter%20Counters%20Installation%20Guide.pdf?alt=media&token=6626d737-95d1-4c1f-8642-cf6ff809c2c3">
          <h5 class="widget-user-desc" style="margin-left: 5%; cursor: pointer;"><i class="fa fa-file-pdf-o"></i> Printer Counters Documentation</h5>
        </a>
      </div>-->
      <div class="box-footer no-padding">
        <transition name="page" mode="out-in">
          <Contact v-if="$route.name === 'Contact'"></Contact>
          <Download v-if="$route.name === 'Download'"></Download>
          <Thanks v-if="$route.name === 'Thanks'"></Thanks>
          <Thanks v-if="$route.name === 'Greeting'"></Thanks>
          <Verify v-if="$route.name === 'Verify'"></Verify>
          <va-login v-if="$route.name === 'Login'" title="Login to Printer Counters"></va-login>
          <va-login v-if="$route.name === 'Guide'" title="Login to Printer Counters"></va-login>
          <va-register v-if="$route.name === 'Register'" title="Please Register Here To Create New Dealer Account"></va-register>
        </transition>
      </div>

      <footerBox></footerBox>


      <!--<div class="root">
        <div class="container">
          <ul class="progressbar">
            <li class="active" v-for="i in steps" :key="i"> </li>
          </ul>
        </div>
      </div>-->


    </div>
  </div>
</template>
<script>
  import VALogin from '../widgets/VALogin'
  import VARegister from '../widgets/VARegister'
  import Contact from '../components/Home/contact'
  import Download from '../components/Home/download'
  import Thanks from '../components/Home/Thanks'
  import Verify from '../components/Home/Verify'
  import footerBox from '../components/Home/footer'
  import { db } from '../firebase'
  export default {
    name: 'login',
    components: {
      'va-login': VALogin,
      'va-register': VARegister,
      Contact,
      Download,
      Thanks,
      Verify,
      footerBox
    },
    data () {
      return {
        currentStep: 3,
        steps: 3
      }
    },
    created () {
      if (this.$route.name === 'Guide') {
        var btnDownloadGuide = document.createElement('a')
        btnDownloadGuide.target = '_blank'
        btnDownloadGuide.href = 'https://firebasestorage.googleapis.com/v0/b/b-info.appspot.com/o/Documentation%2FPrinter%20Counters%20Installation%20Guide.pdf?alt=media&token=6626d737-95d1-4c1f-8642-cf6ff809c2c3'
        btnDownloadGuide.download = 'Printer Counters Installation Guide.pdf'
        btnDownloadGuide.click()
      }
    },
    computed: {
    },
    methods: {
      downloadClient () {
        console.log('downloadClient started...')
        db.ref('Settings/ClientInstaller').once('value', (snapInstaller) => {
          const installer = snapInstaller.val()
          if (installer) {
            var hiddenElement = document.createElement('a')
            hiddenElement.href = installer.DownloadUrl
            // hiddenElement.target = '_blank'
            hiddenElement.download = installer.Name
            hiddenElement.click()
          }
        })
      },
      downloadClientUSB () {
        console.log('downloadClientUSB started...')
        db.ref('Settings/ClientInstallerUSB').once('value', (snapInstaller) => {
          const installer = snapInstaller.val()
          if (installer) {
            var hiddenElement = document.createElement('a')
            hiddenElement.href = installer.DownloadUrl
            // hiddenElement.target = '_blank'
            hiddenElement.download = installer.Name
            hiddenElement.click()
          }
        })
      },
      goHome () {
        console.log('goHome')
        this.$root.goto('Home')
        location.reload(true)
      },
      testFunction () {
        // Call axios
        let vm = this
        let emailData = {
          SendTo: 'abedali1977@gmail.com',
          Subject: 'Thank you for choosing Printer Counters',
          Template: 'test.html',
          TemplateData: {
            FirstName: 'Abed ElSalam',
            LastName: 'Ali',
            Date: '01/07/2020 17:00'
          }
        }
        emailData = {
          SendTo: 'abedali1977@gmail.com',
          Subject: 'HELLO  --- Thank you for choosing Printer Counters',
          Template: 'welcome.html',
          TemplateData: {
            FirstName: 'Abed ElSalam',
            LastName: 'Ali',
            Date: '02/07/2020 17:00'
          }
        }
        let query = '?Data=' + JSON.stringify(emailData)
        // console.log(query)
        // let urlWithQuery = 'https://us-central1-b-info.cloudfunctions.net/SendAlert' + query
        let urlWithQuery = 'http://localhost:5001/b-info/us-central1/SendEmail' + query
        var request = { url: urlWithQuery, method: 'get', responseType: 'json' }
        vm.$axios(request).then(function (response) {
          // callback(response.data)
          console.log(response)
        })
        .catch(function (error) {
          // callback({ Success: false, Data: error })
          console.log(error)
        })
      }
    }
  }
</script>

<style scoped>
  .loginForm {
    padding: 20px;
    padding-top: 40px !important;
  }
  .largeDownlaodBtn {
    background-color: #fff;
    color: rgb(54, 127, 169);
    float: right;
    margin: 10px;
    border: 1px solid #fff !important;
    height: 150px;
    border-radius: 15px !important;
    cursor: pointer;
  }

  .container {
    width: 35%;
    position: absolute;
    z-index: 1;
    margin-top: 20px;
  }

  .progressbar {
    counter-reset: step;
  }

    .progressbar li {
      float: left;
      width: 14.28%;
      position: relative;
      text-align: center;
    }

      .progressbar li:before {
        content: counter(step);
        counter-increment: step;
        width: 30px;
        height: 30px;
        border: 2px solid #bebebe;
        display: block;
        margin: 0 auto 10px auto;
        border-radius: 50%;
        line-height: 27px;
        background: white;
        color: #bebebe;
        text-align: center;
        font-weight: bold;
      }

      .progressbar li:after {
        content: '';
        position: absolute;
        width: 100%;
        height: 3px;
        background: #979797;
        top: 15px;
        left: -50%;
        z-index: -1;
      }

      .progressbar li.active:before {
        border-color: #3aac5d;
        background: #3aac5d;
        color: white
      }

      .progressbar li.active:after {
        background: #3aac5d;
      }

      .progressbar li.active - li:after {
        background: #3aac5d;
      }

      .progressbar li.active - li:before {
        border-color: #3aac5d;
        background: #3aac5d;
        color: white
      }

      .progressbar li:first-child:after {
        content: none;
      }
</style>



// WEBPACK FOOTER //
// Login.vue?4467dcac